import request, { METHODS } from "@/api";
import UrlConfig from "@/api/UrlConfigs.ts";
import { get } from "lodash-es";
/**
 * 服务配置-客户服务列表-新增/编辑服务
 * @param options
 */
export const insertOrUpdateServiceNodeConfig = data => {
    return request(UrlConfig.plusPmWeb.InsertOrUpdateServiceNodeConfig, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务配置-删除
 */
export const deleteServiceNodeConfigById = id => {
    return request(`${UrlConfig.plusPmWeb.DeleteServiceNodeConfigById}?id=${id}`, {
      method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
  }
/**
 * 服务配置-客户服务配置-复制
 * @param options
 */
export const copyServiceNodeConfig = data => {
    return request(UrlConfig.plusPmWeb.CopyServiceNodeConfig, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务配置-列表
 * @param options
 */
export const findServiceNodeConfig = (current, pageSize, data) => {
    return request(`${UrlConfig.plusPmWeb.FindServiceNodeConfig}?current=${current}&pageSize=${pageSize}`, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        const records = get(resp, 'list', [])
        const total = get(resp, 'count', 0)
        return {records, total}
    })
}
/**
 * 服务配置-客户服务配置-根据ID查询
 * @param options
 */
export const findServiceNodeConfigById = id => {
    return request(`${UrlConfig.plusPmWeb.FindServiceNodeConfigById}?id=${id}`, {
        method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-节点管理-删除节点
 * @param options
 */
export const deleteNodeConfigById = id => {
    return request(`${UrlConfig.plusPmWeb.DeleteNodeConfigById}?id=${id}`, {
        method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-节点管理-新增/编辑节点
 * @param options
 */
export const addOrUpdateNodeConfig = data => {
    return request(UrlConfig.plusPmWeb.insertOrUpdateNodeConfig, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}

/**
 * 服务配置-节点管理-列表节点
 * @param options
 */
export const findNodeConfig = (current, pageSize, params) => {
    return request(`${UrlConfig.plusPmWeb.FindNodeConfig}?current=${current}&pageSize=${pageSize}`, {
      method: METHODS.POST,
      data: params,
    }).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return {records, total}
    })
  }
/**
 * 服务配置-节点管理-ID查询
 * @param options
 */
export const findNodeConfigById = id => {
    return request(`${UrlConfig.plusPmWeb.FindNodeConfigById}?id=${id}`, {
        method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
}

/**
 * 服务配置-客户服务配置-新增/编辑详情
 * @param options
 */
export const insertOrUpdateServiceNodeConfigDtl = data => {
    return request(UrlConfig.plusPmWeb.InsertOrUpdateServiceNodeConfigDtl, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务配置-删除详情
 * @param options
 */
export const deleteServiceNodeConfigDtlById = id => {
    return request(`${UrlConfig.plusPmWeb.DeleteServiceNodeConfigDtlById}?id=${id}`, {
        method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务详情-ID查询
 * @param options
 */
export const findServiceNodeConfigDtlById = id => {
    return request(`${UrlConfig.plusPmWeb.FindServiceNodeConfigDtlById}?id=${id}`, {
        method: METHODS.POST,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务详情-列表
 * @param data
 */
export const findServiceNodeConfigDtl = data => {
    return request(UrlConfig.plusPmWeb.FindServiceNodeConfigDtl, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 服务配置-客户服务详情-排序
 * @param data
 */
export const sortNumServiceNodeConfigDtl = data => {
    return request(UrlConfig.plusPmWeb.sortNumServiceNodeConfigDtl, {
        method: METHODS.POST,
        data: data,
    }).then((resp: any) => {
        return resp
    })
}